import React from 'react';
import withUser from '../../../../lib/WithUser';
import withProperty from '../../WithProperty';
import MiscSearch from './MiscSearch';

const searchTypeId = 76;

const MiscSearch2 = (props: any) => {
  return <MiscSearch {...{ ...props, searchTypeId }} />;
};

export default withProperty(withUser(MiscSearch2), searchTypeId, true);
